import Tooltip from "../../../components/Common/Tooltip";
import { EyeOutlined } from "@ant-design/icons";

export const formatFileExtension = (type, fileName) => {
  if (type) {
    const extension = type.split("/")[1]?.toUpperCase() || "N/A";
    if (extension !== "N/A") {
      return extension;
    }
  }
  
  if (fileName) {
    const extension = fileName.split(".").pop()?.toUpperCase() || "N/A";
    return extension;
  }
  
  return "N/A";
};

export const formatFileSize = (size) => {
  if (!size) return "N/A";
  const sizeKB = (size / 1024).toFixed(1);
  return `${sizeKB} KB`;
};

export const formatLastModified = (lastModified) => {
  if (!lastModified) return "N/A";
  return new Date(lastModified).toLocaleDateString();
};

export const renderFileNameWithTooltip = (name) => {
  if (!name) return "N/A";

  const containerStyles = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    width: "100%",
    display: "block",
    textAlign: "left",
    cursor: "default",
  };

  return (
    <Tooltip text={name}>
      <div style={containerStyles}>
        {name}
      </div>
    </Tooltip>
  );
};

export const renderActionsColumn = (abrirModalDocumento) => (_, record) => {
  const buttonStyles = {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#1890ff",
    fontSize: "16px",
  };

  const containerStyles = {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
  };

  return (
    <div style={containerStyles}>
      <button
        onClick={() => abrirModalDocumento(record)}
        style={buttonStyles}
        title="Ver documento"
      >
        <EyeOutlined />
      </button>
    </div>
  );
};

export const ANEXOS_TABLE_COLUMN_WIDTHS = {
  NOMBRE: "35%",
  CODIGO_COBERTURA: "15%",
  TIPO: "10%",
  TAMANO: "10%",
  FECHA: "12%",
  ACCIONES: "18%",
};

export const ANEXOS_TABLE_STYLES = `
  .anexos-table-wrapper table {
    table-layout: fixed !important;
    width: 100% !important;
  }
  .anexos-table-wrapper table th,
  .anexos-table-wrapper table td {
    overflow: visible !important;
    position: relative !important;
  }
  .anexos-table-wrapper table th:nth-child(1),
  .anexos-table-wrapper table td:nth-child(1) {
    width: ${ANEXOS_TABLE_COLUMN_WIDTHS.NOMBRE} !important;
    max-width: ${ANEXOS_TABLE_COLUMN_WIDTHS.NOMBRE} !important;
  }
  .anexos-table-wrapper table th:nth-child(2),
  .anexos-table-wrapper table td:nth-child(2) {
    width: ${ANEXOS_TABLE_COLUMN_WIDTHS.CODIGO_COBERTURA} !important;
    max-width: ${ANEXOS_TABLE_COLUMN_WIDTHS.CODIGO_COBERTURA} !important;
  }
  .anexos-table-wrapper table th:nth-child(3),
  .anexos-table-wrapper table td:nth-child(3) {
    width: ${ANEXOS_TABLE_COLUMN_WIDTHS.TIPO} !important;
    max-width: ${ANEXOS_TABLE_COLUMN_WIDTHS.TIPO} !important;
  }
  .anexos-table-wrapper table th:nth-child(4),
  .anexos-table-wrapper table td:nth-child(4) {
    width: ${ANEXOS_TABLE_COLUMN_WIDTHS.TAMANO} !important;
    max-width: ${ANEXOS_TABLE_COLUMN_WIDTHS.TAMANO} !important;
  }
  .anexos-table-wrapper table th:nth-child(5),
  .anexos-table-wrapper table td:nth-child(5) {
    width: ${ANEXOS_TABLE_COLUMN_WIDTHS.FECHA} !important;
    max-width: ${ANEXOS_TABLE_COLUMN_WIDTHS.FECHA} !important;
  }
  .anexos-table-wrapper table th:nth-child(6),
  .anexos-table-wrapper table td:nth-child(6) {
    width: ${ANEXOS_TABLE_COLUMN_WIDTHS.ACCIONES} !important;
    max-width: ${ANEXOS_TABLE_COLUMN_WIDTHS.ACCIONES} !important;
  }
  .anexos-table-wrapper table td:first-child > div {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  .anexos-table-wrapper table td:first-child [class*="StyledTooltip"] {
    position: static !important;
  }
  .anexos-table-wrapper table td:first-child [class*="StyledTooltipContent"] {
    z-index: 9999 !important;
    position: absolute !important;
    max-width: 300px !important;
    word-wrap: break-word !important;
    white-space: normal !important;
  }
`;

